import * as Actions from '../../../redux/actions'

import {
    DELAY_ZERO_SECOND,
    validate,
    validate_fields,
} from "../Common/RegExValidate"

import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import InputBase from '@material-ui/core/InputBase'
import React from 'react'
import SearchBarAutocomplete from "./SearchBarAutocomplete"
import { SearchIcon } from "../Common/SVGBank"
import { TimesIcon } from "../Common/SVGBank"
import { connect } from "react-redux"
import { makeStyles } from '@material-ui/core/styles'

const searchStyles = makeStyles((theme) => ({
    title: {
        flexGrow: 1,
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    search: {
        background: "#FFFFFF 0% 0% no-repeat padding-box",
        boxShadow: "0px 3px 6px #00000029",
        border: "1px solid #B1B1B1",
        borderRadius: "4px",
        position: 'relative',
        marginTop: "15px",
        [theme.breakpoints.up('sm')]: {
            // marginLeft: theme.spacing(1),
            width: 'auto',
        },
        height: '40px',
        width: "100%",
    },
    inputRoot: {
        color: 'var(--bgBlack)',
        font: "16px/16px Futura Md BT",
        width: "100%",
    },
    inputInput: {
        padding: theme.spacing(1, 0, 1, 1),
        // vertical padding + font size from searchIcon
        paddingRight: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '20ch',
            // '&:focus': {
            //     width: '20ch',
            // },
        },
    },
}))
export const SearchBar = connect((state) => {
    return {
    lang: state.Setting.lang,
    activeFeatureId: state.Feature.feature.activeId,
    featureSearchList: state.Feature.feature.featureSearchList,
    searchQuery: state.Feature.feature.loading.searchQuery,
    loading: state.Feature.feature.loading,
    types: state.Feature.feature.types,
    destinationId: state.Destination.destination.activeId,
}}, {
    cleanSearchQueryFeature: Actions.cleanSearchQueryFeature,
    setSearchQueryFeature: Actions.setSearchQueryFeature,
    setSwitchFeatureTypeContainerOfFeature: Actions.setSwitchFeatureTypeContainerOfFeature,
    setSearchFeatureListFeature: Actions.setSearchFeatureListFeature,
    cleanSelectedDestinationsFeature: Actions.cleanSelectedDestinationsFeature,
    cleanSelectedSubTypeFeature: Actions.cleanSelectedSubTypeFeature,
},
)(({
    lang,
    types,
    searchQuery,
    activeFeatureId,
    featureSearchList,
    setSearchQueryFeature,
    loading,
    cleanSearchQueryFeature,
    setSwitchFeatureTypeContainerOfFeature,
    cleanSelectedDestinationsFeature,
    setSearchFeatureListFeature,
    cleanSelectedSubTypeFeature,
    destinationId,
    isDestination
}) => {
    const [query, setQuery] = React.useState("")
    const [autocompleteOpen, setAutocomplete] = React.useState((query?.length > 0 && featureSearchList.length > 0) || false)
    React.useEffect(() => {
        setQuery(searchQuery)
        setSwitchFeatureTypeContainerOfFeature(activeFeatureId, lang, types, null)
       // cleanSelectedDestinationsFeature()
        cleanSelectedSubTypeFeature()
    }, [searchQuery])

    React.useEffect(() => {
      
        setAutocomplete((query?.length > 0 && featureSearchList.length > 0))
    }, [featureSearchList])

    React.useEffect(() => {
        setAutocomplete(false)
        setQuery("")
       
        return () => {
            setAutocomplete(false)
            setQuery("")
        }
    }, [destinationId])


    const anchorRef = React.useRef(null);
    const classes = searchStyles()
    const delay = (() => {
        let timer = 0
        return (callback, ms) => {
            clearTimeout(timer)
            timer = setTimeout(callback, ms)
        }
    })()
    const updateState = (search, error) => {
        if (!error) {
            const destination = isDestination ? [{id: destinationId}]: null;
            setSearchQueryFeature(search, activeFeatureId, lang,destination)
          
        }
    }
    const handleChangeHandleTextField = event => {
        let search = event.target.value
        setQuery(search)
        delay(function () {
            updateState(search, !validate(String(search).trim(), validate_fields.search))
        }, DELAY_ZERO_SECOND)
    }
      const searchFilter = () =>{
          if(query && query.length > 0){
            setSearchFeatureListFeature(query, activeFeatureId,loading,lang)
            setAutocomplete(false) 
          }
   
          else{
             handleClose()
          }
     
    }

    const handleCloseAway = event => {
        // if (anchorRef.current && anchorRef.current.contains(event.target)) {
        //     return;
        // }
        setQuery("")
        setSearchQueryFeature("")
        cleanSearchQueryFeature()
    };
    const handleClose = event => {
        setQuery("")
        setSearchQueryFeature("")
        cleanSearchQueryFeature()
        setSearchFeatureListFeature('', activeFeatureId,loading,lang)
    };
    const handleEreser = () => {
        setQuery("")
        setSearchQueryFeature("")
        cleanSearchQueryFeature()
        setSearchFeatureListFeature('', activeFeatureId,loading,lang)
    }
    return (

        <ClickAwayListener onClickAway={handleCloseAway}>
            <div
                ref={anchorRef} style={{ position: "relative" }}>
                <div className={classes.search}>

                    <InputBase
                        placeholder="Search"
                        classes={{
                            root: classes.inputRoot,
                            input: classes.inputInput,
                        }}
                        inputProps={{ 'aria-label': 'search' }}
                        onChange={handleChangeHandleTextField}
                        value={query}
                        // value={""}
                    />
                  
                
                </div>
                {
                    <div
                        style={{
                            cursor: "pointer",
                            right: "10px",
                            bottom: "12px",
                            position: 'absolute',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        onClick={() => searchFilter()}>
                            {query && <span style={{paddingRight:10, cursor: "pointer",}} onClick={handleClose}>  <TimesIcon width={13} height={13} /></span>}
                           <SearchIcon/>
                    </div>}
            
                {autocompleteOpen && < SearchBarAutocomplete
                    anchorRef={anchorRef}
                    handleClose={handleClose}
                    open={autocompleteOpen}
                />}
            </div>
        </ClickAwayListener>
    )
})
